import classNames from "classnames";
import React from "react";

import withTranslations from "../../../../../../hocs/withTranslations";
import useIsDesktop from "../../../../landingPage/hooks/useIsDesktop";
import FilterOptionsHelper from "../../../../../../lib/UniversalTable/CoreHelpers/FilterOptionsHelper";
import TrendStatusHelper from "../../../../../../lib/UniversalTable/RendererHelpers/TrendStatusHelper";
import LandingTypography from "../../../../landingPage/components/LandingTypography";
import { TrendStatusArrows } from "../TrendStatusArrows/TrendStatusArrows";

const TrendStatusLegendItem = ({ optionValue, column, translate }) => {
  const arrows = TrendStatusHelper.render(optionValue);

  if (!arrows) {
    return null;
  }

  return (
    <li className="m-0 p-0">
      <span className="flex flex-wrap items-center gap-2 text-sm font-medium leading-100 text-black">
        <span className="inline-flex items-center shrink-0">
          <TrendStatusArrows arrows={arrows} />
        </span>
        <span className="break-words">
          {translate(
            FilterOptionsHelper.getOptionTranslationKey(column, optionValue)
          )}
        </span>
      </span>
    </li>
  );
};

const TrendStatusLegend = ({ column, translate }) => {
  const isDesktop = useIsDesktop();
  const optionKeys = FilterOptionsHelper.getFilterOptionKeys(column);

  if (isDesktop) {
    return null;
  }

  return (
    <LandingTypography
      className={classNames("landing-typography_dark", "bg-white", "mt-14")}
    >
      <h2 className="text-xl font-bold leading-130 text-black mb-8">
        {translate(column.label)}
      </h2>
      <ul className="list-none m-0 p-0 grid gap-x-6 gap-y-6 grid-cols-1">
        {optionKeys.map(optionValue => (
          <TrendStatusLegendItem
            key={optionValue}
            optionValue={optionValue}
            column={column}
            translate={translate}
          />
        ))}
      </ul>
    </LandingTypography>
  );
};

export default withTranslations(TrendStatusLegend);
